class CSV {

  constructor() {
    this.useHeader = false;
    this.header = [];
    this.data = [];

    // this.metadataLine = 0;
    // this.headerLine = 1;
    // this.column = 0;
    // this.data[0] = [];
    // this.data[1] = [];
    // this.data[2] = [];

    // 操作系
    // this.x = 0;
    // this.y = 0;
    //this.currentLine = 2;
  }
  // setColumn(num){
  //   this.column = num;
  // }

  // pushMetadata(data){
  //   this.data[0].push(data);
  // }

  // pushHeader(data){
  //   this.data[1].push(data);
  // }

  // pushData(data){
  //   this.data[this.currentLine].push(data);
  // }

  // pushNextLine(){
  //   this.currentLine += 1;
  //   this.data[this.currentLine] = [];
  // }

  // getText( col, row ){
  //   // メタデータを省いた位置のデータを返す
  //   return this.data[row+2][col+1];
  // }

  // getHeader(){
  //   if( this.data[0] ){
  //     return this.data;
  //   }
  //   return null;
  // }
  // getCSVData(){
  //   // データが存在するかチェック
  //   if( !this.data[1] ){
  //     return null;
  //   }

  //   const datas = [];

  //   var index = 0;
  //   for( const line of this.data ){
  //     if( index === 0 ){
  //       index += 1;
  //       continue;
  //     }

  //     // データのヘッダーがいじられていない想定
  //     var data = {};
  //     data.posX = line[0];
  //     data.posY = line[1];
  //     data.rotate = line[2];
  //     data.size = line[3];
  //     data.type = line[4];
  //     data.color = line[5];
  //     data.text = line[6];
  //     datas.push(data);
  //   }

  //   return datas;
  // }
  // pushLine( ...args ){
  //   this.data[this.currentLine] = [];
  //   args.forEach( function(element){
  //     this.data[this.currentLine].push(element);
  //   }.bind(this) );
  //   this.currentLine += 1;
  // }

  // 編集データをcsvデータ化しダウンロードまでを行う
  exportData( fileName = "file.csv" ){
    let csvString = "";

    // ヘッダー
    console.log(this.header);
    if( this.useHeader ){
      const headerLen = this.header.length;
      for( let i=0; i<headerLen; ++i ){
        csvString += this.header[i];
        // 最終列以外はカンマを挿入
        if( (i+1) != headerLen ){
          csvString += ",";
        }
      }

      // 最終列は改行コードを追加
      csvString += '\r\n';
    }

    // データ
    console.log(this.data);
    const column = this.data.length;
    for( let i=0; i<column; ++i ){
      const row = this.data[i].length;
      for( let j=0; j<row; ++j ){
        csvString += this.data[i][j];
        // 最終列以外はカンマを挿入
        if( (j+1) != row ){
          csvString += ",";
        }
      }
      // 最終列は改行コードを追加
      csvString += '\r\n';
    }

    // blob化
    let blob = new Blob([csvString], {type: "text/csv"});

    // ダウンロード
    let uri = URL.createObjectURL( blob );
    let link = document.createElement("a");
    link.href = uri;
    link.download = fileName;
    link.click();
  }

  importFile(blob){
    const fileReader = new FileReader();
    fileReader.readAsText(blob);  // utf-8

    return new Promise((resolve)=>{
      fileReader.onload = function () {
        const fileLines = fileReader.result.split('\r\n');
        // データを初期化
        var currentLine = 0;
        this.data = [];

        if( fileLines.length == 0 ) {
          resolve();
          return;
        }

        for( const line of fileLines ){
          const datas = line.split(',');
          this.data[currentLine] = [];

          for( const element of datas ){
            this.data[currentLine].push(element);
          }
          currentLine += 1;
        }

        this.column = fileLines[0].split(',').length;

        //console.log( this.data) ;	// 文字列
        resolve();
      }.bind(this);
    });
  }

  // 列のデータを取得
  // 列名で取得
  // importFileをしてから実行
  getColData( colName ){
    if( this.data == [] ) return;

    // Noはスキップ
    for( let i=1; i<this.column; ++i ){
      if( this.data[0][i] == colName ){
        // 列名が一致したらデータを配列化し返却
        let result = [];
        for( let j=1; j<this.data.length; ++j ){
          result.push(this.data[j][i]);
        }
        return result;
      }
    }

    return null;
  }

}
export { CSV }